import { render, staticRenderFns } from "./NuevoArticulo.vue?vue&type=template&id=1e4b563f&"
import script from "./NuevoArticulo.vue?vue&type=script&lang=js&"
export * from "./NuevoArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports